import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

export interface BadgeItem {
  type: string;
  value: string;
}
export interface Saperator {
  name: string;
  type?: string;
}
export interface SubChildren {
  state: string;
  key: string;
  name: string;
  type?: string;
}
export interface ChildrenItems {
  state: string;
  key: string;
  name: string;
  type?: string;
  child?: SubChildren[];
}

export interface Menu {
  state: string;
  key: string;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  saperator?: Saperator[];
  children?: ChildrenItems[];
}

const MENUITEMS : Array<Menu> = [
  {
    state: 'dashboard',
    key: 'dashboard',
    name: 'Dashboard',
    type: 'sub',
    icon: 'dashboard',
    children: [
      { state: 'awv', key: 'awv', name: 'Annual Wellness Visit', type: 'link' },
      { state: 'ccm', key: 'ccm', name: 'Chronic Care Management', type: 'link' },
      { state: 'ccm', key: 'bh', name: 'Behavioral Health', type: 'link' },
      { state: 'ccm', key: 'rpm', name: 'Remote Patient Monitoring', type: 'link' }
    ]
  },
  {
    state: 'patient',
    key: 'patient',
    name: 'Patients',
    type: 'link',
    icon: 'av_timer'
  },
  {
    state: 'rewards',
    key: 'rewards',
    name: 'MyCareRewards',
    type: 'link',
    icon: 'card_giftcard'
  },
  {
    state: 'communication',
    key: 'communication',
    name: 'Communication',
    type: 'link',
    icon: 'chat'
  },
  {
    state: 'activities',
    key: 'activities',
    name: 'Activities',
    type: 'link',
    icon: 'local_activity'
  },
  {
    state: 'knowledge_base',
    key: 'knowledge_base',
    name: 'Knowledge Base',
    type: 'link',
    icon: 'info'
  },
  {
    state: environment.yellowfin.url,
    key: 'report',
    name: 'MyCareInsights',
    type: 'extTabLink',
    icon: 'assessment'
  },
  {
    state: 'insights',
    key: 'insights',
    name: 'Interactive Insights',
    type: 'link',
    icon: ' lightbulb'
  },
  {
    state: 'social-determinants',
    key: 'social-determinants',
    name: 'Social Determinants',
    type: 'link',
    icon: ' people'
  },
]
/**
 * This is class contains the configuration for menu items, If you need to add a new menu item in sidebar then you need to add that item here
 */
@Injectable()
export class MenuItems {
  getMenuitem(): Menu[] {
    return MENUITEMS;
  }
}
